import axios, { AxiosInstance } from "axios";

export class ApiClient {
  public instance: AxiosInstance;
  private azureKey: string;

  constructor(baseURL: string) {
    this.azureKey = process.env.REACT_APP_AZURE_FUNCTION_KEY || "";

    this.instance = axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Automatically add the key to every request
    this.instance.interceptors.request.use((config) => {
      if (!config.params) config.params = {};
      config.params.code = this.azureKey;
      return config;
    });
  }

  // Method to set the Authorization token
  setAuthToken(token: string) {
    this.instance.defaults.headers.Authorization = `Bearer ${token}`;
  }

  // Optional method to clear the token (e.g., on logout)
  clearAuthToken() {
    delete this.instance.defaults.headers.Authorization;
  }
}
